import axios from "axios";
import { trackExternal } from "@/lib/analytics";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const EBOOK = {
  title: "The Crowned Perfect Photo Guide",
  subtitle: "Choose the right photograph for your Crowned masterpiece.",
  url: "https://payhip.com/b/CrvDA",
  cover: "/ebook-cover.webp",
};

export const INTAKE_FORM_URL = "https://forms.gle/WUig6FRWWNKiA3zX9";
export const CREATIVE_QUESTIONNAIRE_URL = "https://forms.gle/UZbBGWTNe4yb73MBA";
// Official transparent Crowned logo — served locally for performance. Do not
// restyle, crop, recolor or place a solid background behind it.
export const LOGO_URL = "/crowned-logo.png";

export const track = (event, source = "", meta = {}) => {
  trackExternal(event, source, meta);
  try {
    axios.post(`${API}/analytics/track`, { event, source, meta }).catch(() => {});
  } catch (_) {}
};

export const submitEbookLead = async ({ email, name = "", phone = "", sms_consent = false, source = "popup" }) => {
  const { data } = await axios.post(`${API}/ebook-leads`, { email, name, phone, sms_consent, source });
  track("ebook_lead_submitted", source);
  return data;
};

export const openEbook = (source = "unknown") => {
  track("ebook_click", source);
  window.open(EBOOK.url, "_blank", "noopener,noreferrer");
};

export const openIntake = (source = "unknown") => {
  track("intake_click", source);
  window.open(INTAKE_FORM_URL, "_blank", "noopener,noreferrer");
};

export const openQuestionnaire = (source = "unknown") => {
  track("questionnaire_click", source);
  window.open(CREATIVE_QUESTIONNAIRE_URL, "_blank", "noopener,noreferrer");
};
